<section class="get-labels" data-testid="get-labels">
  <app-shipment-stepper [activeStepIndex]="activeStepIndex" [completeActiveStep]="true" />

  @if (showPageSkeleton()) {
    <div class="get-labels__content" aria-busy="true">
      <app-get-labels-skeleton />
    </div>
  } @else if (confirmation(); as completed) {
    <div class="get-labels__content">
      <header class="get-labels__header">
        <puro-typography component="h2" variant="h2" class="get-labels__title">
          {{ 'createShipment.getLabels.title' | translate }}
        </puro-typography>
      </header>

      @if (completed.cancelled) {
        <app-alert-toast
          severity="success"
          [message]="'createShipment.getLabels.cancelledSuccess' | translate"
          data-testid="get-labels-cancelled-toast"
        />
      } @else {
        <app-alert-toast
          severity="success"
          [message]="'createShipment.getLabels.successMessage' | translate"
          [tooltipContent]="'createShipment.getLabels.successTooltip' | translate"
          [tooltipAriaLabel]="'createShipment.getLabels.successTooltipAria' | translate"
          data-testid="get-labels-success-toast"
        />
      }

      @if (cancelErrorKey(); as errorKey) {
        <app-alert-toast
          severity="error"
          live="assertive"
          [message]="errorKey | translate"
          data-testid="get-labels-cancel-error"
        />
      }

      @if (hasShipmentDetailsError()) {
        <app-alert-toast
          severity="error"
          live="assertive"
          data-testid="get-labels-shipment-details-error"
        >
          <div class="get-labels__shipment-details-error-content">
            <puro-typography
              component="p"
              variant="body1"
              class="get-labels__shipment-details-error-title"
            >
              <strong>
                {{ 'createShipment.getLabels.shipmentDetailsGenerationErrorTitle' | translate }}
              </strong>
            </puro-typography>
            <puro-typography
              component="p"
              variant="body1"
              class="get-labels__shipment-details-error-body"
            >
              {{ 'createShipment.getLabels.shipmentDetailsGenerationErrorBody' | translate }}
              <strong class="get-labels__shipment-details-error-phone">{{
                'createShipment.getLabels.shipmentDetailsGenerationErrorPhone' | translate
              }}</strong
              >.
            </puro-typography>
          </div>
        </app-alert-toast>
      }

      <app-get-labels-details-toggle
        [expanded]="detailsExpanded()"
        [downloadState]="shipmentDetailsDownloadState()"
        (expandedChange)="onDetailsExpandedChange($event)"
        (downloadRequested)="onShipmentDetailsDownload()"
      >
        @if (detailsExpanded()) {
          <app-get-labels-shipment-details
            [shipFromView]="summaryViews().shipFromView"
            [shipToView]="summaryViews().shipToView"
            [returnView]="summaryViews().returnView"
            [packagingView]="summaryViews().packagingView"
            [additionalServicesView]="summaryViews().additionalServicesView"
            [inductionView]="summaryViews().inductionView"
            [locatorUrl]="summaryViews().dropOffLocatorUrl"
          />
        }
      </app-get-labels-details-toggle>

      @if (!completed.cancelled) {
        <app-get-labels-label-ready
          [trackingPin]="completed.trackingPin"
          [state]="labelState()"
          [showGenerationError]="hasLabelError()"
          (actionRequested)="onLabelAction()"
        />
      }

      @if (summaryViews().selectedService; as selectedService) {
        <app-get-labels-estimated-costs
          [selectedService]="selectedService"
          [breakdown]="summaryViews().breakdown"
          [paymentDisplay]="paymentDisplay()"
        />

        <app-alert-toast
          severity="warning"
          [message]="'createShipment.getLabels.costChangeWarning' | translate"
          [tooltipContent]="'createShipment.reviewAndPay.terms.quote' | translate"
          [tooltipAriaLabel]="'createShipment.getLabels.costChangeWarningTooltipAria' | translate"
          data-testid="get-labels-cost-warning"
        />
      }

      <hr class="get-labels__actions-divider" data-testid="get-labels-actions-divider" />

      <app-get-labels-actions
        [cancelDeadlineLocal]="completed.cancelDeadlineLocal"
        [cancelAvailable]="cancelAvailable()"
        (cancelRequested)="onCancelShipmentRequested()"
        (createNewShipment)="onCreateNewShipment()"
      />
    </div>
  }
</section>

<app-get-labels-cancel-shipment-dialog
  [open]="cancelDialogOpen()"
  [submitting]="cancelSubmitting()"
  [trackingPin]="confirmation()?.trackingPin ?? ''"
  [shipmentCreationDate]="confirmation()?.shipmentCreationDate ?? ''"
  [hasAssociatedPickup]="hasAssociatedPickup()"
  (dismissed)="onCancelShipmentDismissed()"
  (confirmed)="onCancelShipmentConfirmed()"
/>

@if (confirmation(); as completed) {
  <app-get-labels-cancelled-shipment-dialog
    [open]="cancelledDialogOpen()"
    [trackingPin]="completed.trackingPin"
    [shipmentCreationDate]="completed.shipmentCreationDate"
    [hasAssociatedPickup]="hasAssociatedPickup() || pickupCancelledOnCancel()"
    (backToHome)="onCancelledBackToHome()"
  />
}
